import React, {Fragment,useState, useEffect} from "react";
import ListBeneficiariosWrapperTallaje from "./ListBeneficiariosWrapperTallaje";

const DisplayListBeneficiarios = ({listBenefTallaje, isFiltered}) => {
  const [hasNextPage,setHasNextPage] = useState(true);
  const [isNextPageLoading,setIsNextPageLoading] = useState(false);
  const [items,setItems] = useState(listBenefTallaje);

  const _loadNextPage = (...args) => {
    setIsNextPageLoading(true);
    setHasNextPage(items.length < listBenefTallaje.length );
    setIsNextPageLoading(false);
   
    if (isFiltered){
      setItems([]); //Object.assign({}, listBenefTallaje[10])
    } else {
      setItems( [...items].concat(listBenefTallaje[args[0]]) );
    }
    
  };

  useEffect(() => {
    if (isFiltered){
      setHasNextPage(false );
      setIsNextPageLoading(false);
      setItems(listBenefTallaje);
    } else {
      setItems([]);
      setIsNextPageLoading(true);
      setHasNextPage(true );
      setIsNextPageLoading(false);
      setItems(listBenefTallaje);
    }
      
  }, [isFiltered, listBenefTallaje]);


if (items)
  return (
    <Fragment>
      <ListBeneficiariosWrapperTallaje 
          hasNextPage={hasNextPage}
          isNextPageLoading={isNextPageLoading}
          items={items}
          loadNextPage={_loadNextPage}
        />

    </Fragment>
  );
  return (
    <></>
  )
}

export default DisplayListBeneficiarios;
